import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  type: string
  name: string
  id: number
  icon: string | null
  openMemberModalCallback: (param: any) => void
}

const MemberBlock: FC<Props> = (props) => {
  const {
    type,
    name,
    id,
    icon,
    openMemberModalCallback,
  } = props

  const { t } = useTranslation()

  return (
    <div className={`member_block ${type}`}>
      <div className="user_icon">
        {
          icon ? (
            <img alt="" src={icon} />
          ) : (
            <img alt="" src={`/static/images/profile/${(id || 0) % 12}.jpeg`} />
          )
        }
      </div>
      <div>
        <div className="role">
          {type}
        </div>
        <div className="name no_trans">
          {name}
        </div>
        {
          type === "member" && (
            <div
              className="view_report"
              onClick={() => openMemberModalCallback(
                {
                  member_id: id,
                  member_name: name,
                },
              )}
              role="none"
            >
              {t('report.list.box.view_member_report')}
            </div>
          )
        }
      </div>
    </div>
  )
}

export default MemberBlock
